import { TutorialRule, TutorialRuleOperator } from '@models/tutorial.model'

/**
 * Espelho de App/utils/TutorialAudience.ts na API: se as duas divergirem, o
 * alcance mostrado no formulário passa a mentir.
 */
function normalizeClassName(value: string): string {
	return (value ?? '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.trim()
		.toLowerCase()
}

function ruleMatchesClassName(
	operator: TutorialRuleOperator,
	value: string,
	className: string
): boolean {
	const needle = normalizeClassName(value)
	const haystack = normalizeClassName(className)

	if (!needle) {
		return false
	}

	if (operator === 'starts_with') {
		return haystack.startsWith(needle)
	}

	if (operator === 'ends_with') {
		return haystack.endsWith(needle)
	}

	return haystack.includes(needle)
}

export const ruleOperatorLabels: Record<TutorialRuleOperator, string> = {
	contains: 'contém',
	starts_with: 'começa com',
	ends_with: 'termina com',
}

export function resolveAudience({
	classes,
	classIds,
	rules,
}: {
	classes: Array<{ id: number; name: string }>
	classIds: number[]
	rules: TutorialRule[]
}) {
	const selected = new Set(classIds)
	const byRule = new Set<number>()

	classes.forEach((current) => {
		const matched = rules.some((rule) =>
			ruleMatchesClassName(rule.operator, rule.value, current.name)
		)

		if (matched) {
			byRule.add(current.id)
		}
	})

	const reached = classes.filter(
		(current) => selected.has(current.id) || byRule.has(current.id)
	)

	return {
		reached,
		matchedByRuleOnly: reached.filter(
			(current) => !selected.has(current.id) && byRule.has(current.id)
		),
	}
}
